/** */
import {
  ADD_ONE_TENANT_TO_STORE,
  ADD_MANY_TENANTS_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  REMOVE_MANY_TENANTS_FROM_STORE,
  REMOVE_ONE_TENANT_FROM_STORE,
  LOAD_TENANTS_TO_STORE
} from '../actions/tenant';

export default (state = {}, action) => {
  const { type, payload } = action;
  const current_state = state;
  switch (type) {
    case ADD_MANY_TENANTS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (tenants, tenant) => ({
            ...tenants,
            [tenant.id]: tenant
          }),
          {}
        )
      };
    case ADD_ONE_TENANT_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (tenants, tenant) => ({
            ...tenants,
            [tenant.id]: tenant
          }),
          {}
        )
      };
    case LOAD_TENANTS_TO_STORE:
      return {
        ...payload.reduce(
          (tenants, tenant) => ({
            ...tenants,
            [tenant.id]: tenant
          }),
          {}
        )
      };
    case REMOVE_MANY_TENANTS_FROM_STORE:
      payload.forEach((id) => delete current_state[id]);
      return {
        ...current_state
      };
    case REMOVE_ONE_TENANT_FROM_STORE:
      delete current_state[payload];
      return { ...current_state };
    default:
      return state;
  }
};
